module.exports = __webpack_public_path__ + "static/img/product_express.8fadb83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_express.jpg
// module id = M0jC
// module chunks = 1